import {DeliveryPoint, DeliveryPointClientType} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Tax} from "@app/core/delivery-point/application/dtos/tax";

export class DeliveryPointMapper {
        private static readonly KEY_CLIENT_TYPE = 'client';
        private static readonly KEY_EMPLOYEE_TYPE = 'employee';
        private static readonly ABBREVIATION_KEY = 'abbreviation';
        
    static deserialize(param: any): DeliveryPoint {
        return {
            code: param.code,
            name: param.name,
            address: param.address,
            postalCode: param.postal_code,
            city: param.city,
            province: param.province,
            language: param.language,
            paymentMethod: param.paymentMethod,
            warehouse: param.warehouse,
            priceHidden: param.priceHidden,
            blocked: param.blocked,
            nif: param.tax,
            // If the tax is not present, it will be undefined and the default value will be used.
            tax: DeliveryPointMapper.deserializeTax(param.salesTax) ?? {abbreviation: 'IVA'},
            clientType: DeliveryPointMapper.deserializeClientType(param.clientType),
        }
    }

    static serialize(param: DeliveryPoint): any {
        return {
            code: param.code,
            name: param.name,
            address: param.address,
            postal_code: param.postalCode,
            city: param.city,
            province: param.province,
            language: param.language,
            paymentMethod: param.paymentMethod,
            warehouse: param.warehouse,
            priceHidden: param.priceHidden,
            blocked: param.blocked,
            tax: param.nif,
            salesTax: DeliveryPointMapper.serializeTax(param.tax),
            clientType: DeliveryPointMapper.serializeClientType(param.clientType),
        }
    }

    private static serializeTax(param: Tax): any | undefined {
        if (param) {
            return {
                [DeliveryPointMapper.ABBREVIATION_KEY]: param.abbreviation,
            }
        }
        return undefined;
    }

    private static deserializeTax(param: any): Tax | undefined {
        if (param) {
            return {
                abbreviation: param[DeliveryPointMapper.ABBREVIATION_KEY],
            }
        }
        return undefined;
    }

    private static deserializeClientType(clientData: string): DeliveryPointClientType {
        switch (clientData) {
            case DeliveryPointMapper.KEY_CLIENT_TYPE:
                return DeliveryPointClientType.CUSTOMER;
            case DeliveryPointMapper.KEY_EMPLOYEE_TYPE:
                return DeliveryPointClientType.EMPLOYEE;
            default:
                return DeliveryPointClientType.CUSTOMER;
        }
    }
    
    private static serializeClientType(clientData: DeliveryPointClientType): string {
        switch (clientData) {
            case DeliveryPointClientType.CUSTOMER:
                return DeliveryPointMapper.KEY_CLIENT_TYPE;
            case DeliveryPointClientType.EMPLOYEE:
                return DeliveryPointMapper.KEY_EMPLOYEE_TYPE;
            default:
                return DeliveryPointMapper.KEY_CLIENT_TYPE;
        }
    }
}
